import {
  AutocompleteArrayInput,
  ReferenceArrayInput,
  translate,
} from "react-admin";
import { FormHelperText, withStyles } from "@material-ui/core";
import React, { Fragment } from "react";

const format = (sensors) =>
  sensors ? sensors.map((d) => d.sensor_id.toString()) : [];
const parse = (sensors) =>
  sensors ? sensors.map((id) => ({ sensor_id: id.toString() })) : [];

const SensorsInput = withStyles((theme) => ({
  helperText: {
    lineHeight: 1.35,
  },
}))(({ translate, classes, ...props }) => (
  <Fragment>
    <ReferenceArrayInput
      {...props}
      perPage={10}
      reference="sensor"
      sort={{ field: "name", order: "ASC" }}
      format={format}
      parse={parse}
    >
      <AutocompleteArrayInput optionText="name" fullWidth />
    </ReferenceArrayInput>
    <FormHelperText className={classes.helperText}>
      {translate("resources.sentinel.fields.sensors.help")}
    </FormHelperText>
  </Fragment>
));
export default translate(SensorsInput);
